/* eslint-disable max-len */
import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'

/**
 * @typedef {import('./js-doc').V2CreateBrokerPaymentRequest} V2CreateBrokerPaymentRequest
 * @typedef {import('./js-doc').V2UpdateBrokerPaymentRequest} V2UpdateBrokerPaymentRequest
 * @typedef {import('./js-doc').V2BrokerPaymentResponse} V2BrokerPaymentResponse
 * @typedef {import('./js-doc').V2DeleteBrokerPaymentRequest} V2DeleteBrokerPaymentRequest
 */
class BrokerPayment {
  constructor () {
    this.baseURL = 'broker-payments'
  }

  /**
   * Create a broker payment 
   * @param {V2CreateBrokerPaymentRequest} payload - V2 broker payment create request body 
   * @returns {Promise<V2BrokerPaymentResponse>} - V2 response body
   */
  async create (payload) {
    try {
      const result = (await (await getAxiosClient(this.baseURL)).post('', payload))
      return result?.data
    }
    catch (error) {
      CError(`Could not create broker payment in V2 API`, error)
      throw error
    }
  }

  /**
   * Delete a broker payment
   * @param {string} id - ID of the broker payment
   * @param {V2DeleteBrokerPaymentRequest} payload - V2 broker payment delete request body
   * @returns {Promise<V2BrokerPaymentResponse>}
   */
  async delete (id, payload) {
    try {
      const result = (await (await getAxiosClient(this.baseURL)).delete(id, { data: payload }))
      return result?.data
    }
    catch (error) {
      CError(`Could not delete broker payment ${id} from V2 API`, error)
      throw error
    }
  }
  /**
   * List broker payments for an invoice
   * @param {string} invoiceId - ID of the invoice
   * @returns {Promise<V2BrokerPaymentResponse[]>} - V2 response body
   */
  async list (invoiceId) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).get('',{
        params: {
          invoiceId,
        },
      })
      return result?.data
    }
    catch (error) {
      CError(`Could not list broker payments for invoice id ${invoiceId} from V2 API`, error)
      throw error
    }
  }

  /**
   * Update a debtor payment
   * @param {string} id - ID of the broker payment
   * @param {V2UpdateBrokerPaymentRequest} payload - V2 broker payment request body
   * @returns {Promise<V2BrokerPaymentResponse>} - V2 response body
   */

  async update (id, payload) {
    try {
      const result = (await (await getAxiosClient(this.baseURL)).patch(id, payload))
      return result?.data
    }
    catch (error) {
      CError(`Could not update broker payment from V2 API`, error)
      throw error
    }
  }
}

export default BrokerPayment
